import { Trans } from '@lingui/react/macro';

import AlertBar from '@/design_system/AlertBar';
import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconPayment from '@/icons/Payment.svg';
import IconReceipt from '@/icons/Receipt.svg';
import { useBrandRequestContext } from '@/layouts/Brand/BrandRequestContext';
import { hasPotentialFutureStep } from '@/models/article';
import { useClientToken } from '@/services/auth';

const EstimateDisclaimer = () => {
  const clientToken = useClientToken();
  const { request } = useBrandRequestContext();

  const hasPaymentStepPotentiallyIncoming = request.articles.some((article) =>
    hasPotentialFutureStep(article, 'payment')
  );

  return hasPaymentStepPotentiallyIncoming ? (
    <AlertBar
      type="warning"
      size="large"
      hideIcon
      title={
        <Stack gap="0.5rem">
          <Stack row gap="0.5rem" flexWrap="nowrap">
            <IconReceipt className="color-warning-700" style={{ fontSize: '1.5rem' }} />
            <Paragraph>
              {!clientToken ? (
                <Trans id="client.new.cart.disclaimer.client-via-store.1">
                  We will provide the client with an estimate shortly.
                </Trans>
              ) : (
                <Trans id="client.new.cart.disclaimer.1">
                  We will provide you with an estimate shortly.
                </Trans>
              )}
            </Paragraph>
          </Stack>
          <Stack row gap="0.5rem" flexWrap="nowrap">
            <IconPayment className="color-warning-700" style={{ fontSize: '1.5rem' }} />
            <Paragraph weight="medium">
              {!clientToken ? (
                <Trans id="client.new.cart.disclaimer.client-via-store.2">
                  If a payment is required, it will only be requested once the client accepts the
                  quote.
                </Trans>
              ) : (
                <Trans id="client.new.cart.disclaimer.2">
                  If a payment is required, it will only be requested once you accept the quote.
                </Trans>
              )}
            </Paragraph>
          </Stack>
        </Stack>
      }
    />
  ) : null;
};

export default EstimateDisclaimer;
